import PropTypes from "prop-types";
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { ReactTitle } from 'react-meta-tags';
import { withTranslation } from 'react-i18next';
import { getSessionInfo } from "../../../Redux/reducer/session";

import MainTemplate from '../../public/mainTemplate';
import AdminMainTemplate from '../../private/mainTemplate';

const adminRoles = ['CASH', 'CASC', 'BSC'];

export class NotFound extends Component {

  constructor(props) {
    super(props);
  }

  notFoundContent() {
    const { errorCode = '404', message, subtitle } = this.props;

    return <div className="not-found">
      <div className="content-message">
        <h2>{errorCode}</h2>
        <h3>error</h3>
        <div className="line"></div>
        <p className="title">{undefined === subtitle ? this.props.t('notFound.subTitle') : subtitle}</p>
        <p>{undefined === message ? this.props.t('notFound.message') : message}</p>
      </div>
    </div>;
  }

  render() {
    const { session: { authenticated, userType } } = this.props;

    const MainComponent = userType !== "" && adminRoles.includes(userType) ? AdminMainTemplate : userType !== "" ? MainTemplate : null;

    return authenticated ? <MainComponent>
      <ReactTitle title={`Página no encontrada - Reverse Factoring`} />
      {this.notFoundContent()}
    </MainComponent>
      :
      <div className="not-found-container" style={{ marginTop: '-50px' }}>
        <ReactTitle title={`Página no encontrada - Reverse Factoring`} />
        {this.notFoundContent()}
      </div>
  }
}

NotFound.propTypes = {
  errorCode: PropTypes.number,
  subtitle: PropTypes.string,
  message: PropTypes.string,
}

export const mapStateToProps = (state) => {
  return {
    session: getSessionInfo(state)
  }
}

export default connect(mapStateToProps, null)(withTranslation()(NotFound));